import React from 'react';
import styled from 'styled-components';

import LanguageDropdown from '@domain/language-dropdown';
import { useVismaConfiguration } from '@services/visitor-management';

import Image from './image';

const Container = styled.div`
  display: flex;
  padding-top: 20px;
  padding-bottom: 60px;
  justify-content: space-between;
  align-items: center;

  @media only screen and (max-width: 1200px) {
    padding: 18px 20px;
  }
`;

function Header() {
  const { configuration } = useVismaConfiguration();
  const logoId = configuration?.generalInformation?.company_logo?.id as
    string | undefined;
  if (!logoId) {
    return null;
  }
  return (
    <Container>
      <Image
        id={logoId}
        alt="logo"
        style={{
          height: 'auto',
          width: 'auto',
          maxHeight: 80,
          maxWidth: '50%',
          objectFit: 'contain'
        }}
      />
      <LanguageDropdown isLabelBlack locales={configuration?.locales} />
    </Container>
  );
}

export default Header;
